import { Box, BoxProps, ColorOptions, Icon, Spacer } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { Title } from '../../comps/Title'
import { Screens } from '../../nav/Screens'

interface HomeScreenItemProps {
  data: any
  onAadhaarCardLinked: any
}

export const HomeScreenItem = ({ data, onAadhaarCardLinked }: HomeScreenItemProps) => {
  const navigation = useNavigation()
  return (
    <Box
      {...styles.container}
      onPress={() => {
        if (!data.navigate) {
          alert('Will be updated soon')
        } else {
          if (data.navigate === Screens.ENTER_CUSTOMER_MOBILE) {
            data.params.onAadhaarCardLinked = onAadhaarCardLinked
          }
          navigation.navigate(
            data.navigate as never,
            {
              type: data.params?.type,
              onAadhaarCardLinked: data.navigate === Screens.ENTER_CUSTOMER_MOBILE ? onAadhaarCardLinked : undefined,
            } as never,
          )
        }
      }}
      underlayColor={'TRANSPARENT'}>
      <Box flexDirection={'row'}>
        <Box {...styles.iconContainer}>
          <Icon id={data.icon} size={28} color="PRIMARY_STORNG" />
        </Box>
        <Spacer direction="horizontal" size={16} />
        <Title title={data.screenName} />
      </Box>
      <Icon id="ARROW_RIGHT" size={20} color="PRIMARY_STORNG" />
    </Box>
  )
}

const styles = {
  container: {
    p: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  } as BoxProps,
  iconContainer: {
    p: 10,
    borderRadius: 24,
    backgroundColor: 'PRIMARY_ULTRA_LIGHT' as ColorOptions,
  } as BoxProps,
}
